import { setHeaders } from '@actions/headers.action';
import { Action, createReducer, on } from '@ngrx/store';

export interface State {
  geoClientCountry: string | null;
  geoClientIp: string | null;
}

export const INITIAL_STATE: State = {
  geoClientCountry: null,
  geoClientIp: null,
};

const reducer = createReducer(
  INITIAL_STATE,
  on(setHeaders, (state, { geoClientCountry, geoClientIp }): State => {
    return {
      ...state,
      geoClientCountry,
      geoClientIp,
    };
  }),
);

export const headersReducer = (state: State, action: Action): State =>
  reducer(state, action);
